import { Box } from "@mui/material";
import FrostedCard from "./FrostedCard";
import { useT } from "src/i18n";

export default function JerryPill({ message }) {
    const t = useT();
    const resolvedMessage = message ?? t("wizard.jerryPill.defaultMessage");
    return (
        <FrostedCard
            sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 1.25,
                borderRadius: "100px",
                padding: "8px 14px 8px 8px",
            }}
        >
            <Box
                component="img"
                src="/mascot/jerry.webp"
                alt={t("wizard.jerryPill.imgAlt")}
                sx={{
                    width: 44,
                    height: 44,
                    borderRadius: "50%",
                    objectFit: "cover",
                    flexShrink: 0,
                }}
            />
            <Box>
                <Box sx={{
                    fontFamily: "'Inter', sans-serif",
                    fontSize: 13,
                    fontWeight: 600,
                    color: "text.primary",
                    lineHeight: 1.3,
                }}>
                    {t("wizard.jerryPill.greeting")}
                </Box>
                <Box sx={{
                    fontFamily: "'Inter', sans-serif",
                    fontSize: 12,
                    color: "text.secondary",
                    lineHeight: 1.3,
                }}>
                    {resolvedMessage}
                </Box>
            </Box>
        </FrostedCard>
    );
}
